import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NewsResponseModel } from '@itb-monorepo/models';


@Injectable({
  providedIn: 'root'
})
export class NewsService {
  private http = inject(HttpClient);

  getNews(language: string): Observable<NewsResponseModel[]> {
    return this.http.get<NewsResponseModel[]>(`https://itbfx.net/wp-admin/admin-ajax.php?action=itb_get_latest_posts&lang=${language}`);
  }
  getImageNews(id: string): Observable<any> {
    return this.http.get(`https://academy.itbfx.com/fa/wp-json/wp/v2/media/` + id);
  }
}
